import React from 'react';
import { BookOpen, Gift, FileText, MessageCircle, CheckCircle2, Lock, Zap, Shield, FileDown, Star, Globe2 } from 'lucide-react';
export function Hero() {
  return <section className="w-full pt-6 pb-16 px-4 md:px-8 max-w-6xl mx-auto" data-id="element-83">
      {/* HERO SECTION */}
      <div className="flex flex-col items-center text-center space-y-5" data-id="element-84">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-100 text-brand-700 font-medium md:text-base text-[12px]" data-id="element-85">
          MEGAPACK LIFE COACH™
        </div>

        <div className="space-y-3 -mt-2.5" data-id="element-86">
          <h1 className="md:text-5xl font-extrabold text-brand-900 tracking-tight max-w-4xl text-[28px]" data-id="element-87">
            Todos tus procesos de coaching. <br className="hidden md:block" data-id="element-88" />
            <span className="text-brand-600" data-id="element-89">
              Resueltos en menos de 5 minutos.
            </span>
          </h1>

          <p className="md:text-xl text-gray-600 max-w-3xl text-[14px] mx-auto" data-id="element-90">
            La guía completa del life coach en español — 50+ sesiones listas,
            herramientas, guiones y programas.{' '}
            <strong data-id="element-91">Todo hecho por ti.</strong>
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-sm md:text-base font-medium text-brand-900" data-id="element-92">
          <div className="flex items-center gap-1.5" data-id="element-93">
            <BookOpen className="w-5 h-5 text-brand-500" data-id="element-94" /> 6 Tomos
          </div>
          <div className="flex items-center gap-1.5" data-id="element-95">
            <Gift className="w-5 h-5 text-brand-500" data-id="element-96" /> 5 Bonos
          </div>
          <div className="flex items-center gap-1.5" data-id="element-97">
            <FileText className="w-5 h-5 text-brand-500" data-id="element-98" /> 400+ páginas
          </div>
          <div className="flex items-center gap-1.5" data-id="element-99">
            <MessageCircle className="w-5 h-5 text-brand-500" data-id="element-100" /> 200+ preguntas
          </div>
          <div className="flex items-center gap-1.5" data-id="element-101">
            <CheckCircle2 className="w-5 h-5 text-brand-500" data-id="element-102" /> Para todo
            cliente
          </div>
        </div>

        <div className="w-full max-w-xl mx-auto mt-2 relative" data-id="element-103">
          <img src="https://cdn.magicpatterns.com/uploads/n3PC7AuG9BoaCrnogai78A/Post_de_Intagram_nueva_coleccion_sencillo_blanco_.png" alt="Megapack Life Coach Bundle" className="w-full h-auto relative z-10 mix-blend-multiply" data-id="element-104" />
        </div>

        <div className="w-full max-w-md mx-auto flex flex-col items-center space-y-4 mt-4" data-id="element-105">
          <a href="#pricing" className="w-full bg-brand-600 hover:bg-brand-700 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-106">
            QUIERO MI MEGAPACK AHORA — $19.90
          </a>

          <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-500 font-medium" data-id="element-107">
            <span className="flex items-center gap-1" data-id="element-108">
              <Lock className="w-4 h-4" data-id="element-109" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-110">
              <Zap className="w-4 h-4" data-id="element-111" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-112">
              <Shield className="w-4 h-4" data-id="element-113" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-114">
              <FileDown className="w-4 h-4" data-id="element-115" /> 100% PDF
            </span>
          </div>
        </div>
      </div>

      {/* SOCIAL PROOF BAR */}
      <div className="mt-20 border-y border-brand-100 py-8" data-id="element-116">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-brand-100" data-id="element-117">
          <div className="flex flex-col items-center justify-center space-y-1" data-id="element-118">
            <span className="text-3xl font-bold text-brand-900" data-id="element-119">+500</span>
            <span className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-120">
              Coaches
            </span>
          </div>
          <div className="flex flex-col items-center justify-center space-y-1" data-id="element-121">
            <span className="text-3xl font-bold text-brand-900" data-id="element-122">6+5</span>
            <span className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-123">
              Tomos y Bonos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center space-y-1" data-id="element-124">
            <span className="text-3xl font-bold text-brand-900 flex items-center gap-1" data-id="element-125">
              4.9/5 <Star className="w-5 h-5 fill-accent text-accent" data-id="element-126" />
            </span>
            <span className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-127">
              Valoración
            </span>
          </div>
          <div className="flex flex-col items-center justify-center space-y-1" data-id="element-128">
            <Globe2 className="w-8 h-8 text-brand-600 mb-1" data-id="element-129" />
            <span className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-130">
              Hispanoamérica
            </span>
          </div>
        </div>
      </div>

      {/* TESTIMONIALS */}
      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-131">
        {[{
        text: 'Antes preparaba cada sesión desde cero, dos horas por cliente. Ahora abro el tomo, elijo la sesión y listo. Recuperé mis noches.',
        author: 'Mariana G.',
        role: 'Life Coach'
      }, {
        text: "Mis clientes empezaron a decirme 'se nota que tienes un método'. Eso antes no pasaba. Renovaron 4 de 5 procesos este trimestre.",
        author: 'Carlos R.',
        role: 'Coach Ontológico'
      }, {
        text: 'Dejé de pasar horas en YouTube buscando ejercicios. El banco de preguntas por sí solo ya vale el precio completo.',
        author: 'Valentina S.',
        role: 'Coach de Vida'
      }].map((testimonial, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-50 flex flex-col space-y-4" data-id="element-132">
            <div className="flex gap-1" data-id="element-133">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-accent text-accent" data-id="element-134" />)}
            </div>
            <p className="text-gray-700 italic flex-grow" data-id="element-135">
              "{testimonial.text}"
            </p>
            <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-136">
              <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-bold" data-id="element-137">
                {testimonial.author.charAt(0)}
              </div>
              <div data-id="element-138">
                <p className="font-bold text-brand-900 text-sm" data-id="element-139">
                  {testimonial.author}
                </p>
                <p className="text-xs text-gray-500" data-id="element-140">{testimonial.role}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}